import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
  standalone: false
})
export class ToastComponent {
  @Input() key?: string;
  @Input() showTransitionOptions?: string = '300ms ease-out';
  @Input() hideTransitionOptions?: string = '250ms ease-in';

  getIcon(severity: string) {
    switch (severity) {
      case 'error':
        return 'fa-regular fa-circle-exclamation';
      case 'warn':
        return 'fa-regular fa-triangle-exclamation';
      case 'success':
        return 'fa-regular fa-circle-check';
      case 'info':
        return 'fa-regular fa-circle-info';
      default:
        return null;
    }
  }
}
